import * as React from 'react';
import { CartContext } from '../../context/CartContext.esm.js';
import '../../context/CartSettingsContext.esm.js';
import 'tslib';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import '../../constants/analytics.esm.js';
import '../../modals/content/index.esm.js';
import '../../modals/content/default_validation_error.esm.js';
import '../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import 'classnames';
import '../../constants/api.esm.js';
import Select from '../Select/index.esm.js';
import styles from './PartnershipCode.module.esm.js';

var PartnershipSearch = function (_a) {
    var onChange = _a.onChange;
    var searchPartnerships = React.useContext(CartContext).searchPartnerships;
    return (React.createElement("div", { className: styles.searchWrapper, "data-testid": "partnerships-search-bar" },
        React.createElement(Select, { loadOptions: searchPartnerships, onChange: onChange, placeholder: "Search by program or partner code" })));
};

export { PartnershipSearch };
//# sourceMappingURL=PartnershipSearch.esm.js.map
